export { default as Money } from './Money';



// WEBPACK FOOTER //
// ./src/components/FormControls/Money/index.ts